module.exports = __webpack_public_path__ + "static/media/logo.b03a7457.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/logo.svg
// module id = 294
// module chunks = 0